import React, { Component } from 'react'
import _ from 'lodash'

import Repository from '../felles/repository'
import Loading from '../felles/loading'
import ArbeidslisteAktiv from './arbeidsliste-aktiv'
import { resolve } from '../dependencies'
import {Maalerstatus} from '../felles/utils/statuskoder'

export default class ArbeidslisteAktivContainer extends Component {

    constructor() {
        super()

        this.state = {
            vannmaalere: [],
            tittel: '',
            beskrivelse: '',
            laster: false
        }

        this._hentArbeidsliste = this._hentArbeidsliste.bind(this)
        this._onDataMotatt = this._onDataMotatt.bind(this)
    }

    componentDidMount() {
        this.setState({
            laster: true
        })
        this._hentArbeidsliste().then(this._onDataMotatt)
    }

    _hentArbeidsliste() {
        return resolve(Repository).hentArbeidslisteMedId(this.props.match.params.ListeId)
    }

    _onDataMotatt(liste) {
        let arbliste = liste

        let alleMaalere = []
        
        _.map(liste.VannmaalerePlanlegging, function (maaler) {
            if (maaler.Status < Maalerstatus.Skiftet)
                alleMaalere.push(maaler)
        })
        
        alleMaalere = _.orderBy(alleMaalere,"Avtaltdato")
        _.map(liste.VannmaalerePlanlegging, function (maaler) {
            if (maaler.Status === Maalerstatus.Skiftet || maaler.Status === Maalerstatus.IkkeSkiftet)
                alleMaalere.push(maaler)
        })

        this.setState({
            vannmaalere: alleMaalere,
            tittel: arbliste.Tittel,
            beskrivelse: arbliste.Beskrivelse,
            id: arbliste.Id,
            laster: false
        })
    }

    render() {
        return (
            <div>
                {
                    this.state.laster ?
                        <Loading tekst="Henter arbeidsliste" />
                        :
                        <ArbeidslisteAktiv tittel={this.state.tittel} beskrivelse={this.state.beskrivelse} id={this.state.id}
                            vannmaalere={this.state.vannmaalere} match={this.props.match} history={this.props.history} />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/utskiftning/arbeidsliste-aktiv-container.jsx